<!-- 案例方案资料 -->
<template>
  <div class="case-data-preview">
    <p class="info-title">案例方案资料</p>

    <div class="ly-container__bg">
      <div class="ly_operation">
        <div class="left">
          <el-button type="primary">上传附件</el-button>

          <el-button>
            批量删除
            <i class="jr-iconjr-icon-delect" />
          </el-button>
        </div>
      </div>
    </div>

    <el-table>
      <el-table-column type="selection" align="center" />

      <el-table-column label="附件名称" align="center"></el-table-column>

      <el-table-column label="附件简介" align="center"></el-table-column>

      <el-table-column label="操作" width="120" align="center">
        <template>
          <button-table content="编辑" icon="jr-iconjr-icon-edit" />
          <button-table content="删除" icon="jr-iconjr-icon-delect" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// components
import ButtonTable from "@/components/ButtonTable.vue";

export default {
  components: {
    ButtonTable
  },
  data() {
    //这里存放数据
    return {};
  }
};
</script>

<style scoped lang="less"></style>
